import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {InitPaymentRequest} from "../models/payment/initPaymentRequest";
import {Observable} from "rxjs";
import {InitPaymentResponse} from "../models/payment/initPaymentResponse";
import {ProcessPaymentDetailsRequest} from "../models/payment/processPaymentDetailsRequest";
import {WalletToWalletPaymentReceipt} from "../models/payment/walletToWalletPaymentReceipt";

@Injectable({
  providedIn: "root"
})
export class AmeriaWalletToWalletService {

  private readonly ENDPOINT_URL: string = environment.apiUrl + '/wallet-to-wallet/payments';

  constructor(private http: HttpClient) {
  }

  public init(initPaymentRequest: InitPaymentRequest, isCommissionActive: boolean): Observable<InitPaymentResponse> {
    const url: string = `${this.ENDPOINT_URL}/init?isCommissionActive=${isCommissionActive}`;
    return this.http.post<InitPaymentResponse>(url, initPaymentRequest);
  }

  public makeBindingPayment(initPaymentRequest: InitPaymentRequest, isCommissionActive: boolean): Observable<WalletToWalletPaymentReceipt> {
    const url: string = this.ENDPOINT_URL + `/binding?isCommissionActive=${isCommissionActive}`;
    return this.http.post<WalletToWalletPaymentReceipt>(url, initPaymentRequest);
  }

  public processAfterInit(request: ProcessPaymentDetailsRequest): Observable<WalletToWalletPaymentReceipt> {
    const url: string = this.ENDPOINT_URL + '/process-after-init';
    return this.http.post<WalletToWalletPaymentReceipt>(url, request);
  }
}
